export type OrganizationCreateInterface = {
  title: string;
  placeholder: string;
  description: string;
  submitBtnText: string;
};

export interface IOrganizationData {
  id: string;
  name: string;
  industry: string | null;
  organization_type: string;
  website: string | null;
  country: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  organization_id: string;
  sub_organizations?: {
    id: string;
    name: string;
    industry: string | null;
    organization_type: string;
    website: string | null;
    country: string | null;
    address: string | null;
    city: string | null;
    state: string | null;
    postal_code: string | null;
    organization_id: string;
  }[];
}

export interface ISFTPServerSession {
  id: string;
  session_name: string;
  session_id: string;
  user_id: string;
  organization_id: string;
  username: string;
  host: string;
  password: string;
  expires_at: string;
  status: string;
  type: string;
  createdAt: string;
  user: {
    id: string;
    image: string | null;
    firstname: string;
    lastname: string;
  };
}

export enum SftpSessionStatus {
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
}

export enum PromptTypeEnum {
  PROJECT = 'Project',
  DASHBOARD = 'Dashboard',
}

export enum OrganisationModeEnum {
  LIVE = 'LIVE',
  DEMO = 'DEMO',
}

export interface IPartners {
  id: string;
  partner_name: string;
  client_id: string;
  status: string;
  databricks_workspace_url: string;
  databricks_http_path: string;
  databricks_catalog: string;
  databricks_schema: string;
  created_at: Date;
}

export interface ClientSecretData {
  id: string;
  client_id: string | null;
  client_secret: string | null;
  status: string;
}

export enum PartnerStatus {
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  REVOKED = 'revoked',
}
